import React from 'react';
import { Star } from 'lucide-react';
export function SocialProofBar() {
  return <div className="inline-flex flex-nowrap items-center gap-3 text-sm md:text-base font-bold text-ink bg-white/80 backdrop-blur-sm py-2 px-4 rounded-full shadow-sm border border-subtle-gray w-fit max-w-full whitespace-nowrap" data-id="element-259">
      <div className="flex items-center gap-1 text-gold shrink-0" data-id="element-260">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5" fill="currentColor" data-id="element-261" />)}
      </div>
      <span className="hidden sm:inline text-subtle-gray shrink-0" data-id="element-262">|</span>
      <span className="shrink-0" data-id="element-263">Trusted by Farmington Hills Families</span>
      <span className="hidden lg:inline text-subtle-gray shrink-0" data-id="element-264">|</span>
      <span className="hidden lg:inline text-storm-red shrink-0" data-id="element-265">
        Free Week Available
      </span>
    </div>;
}